/**
 * 搜索历史管理（localStorage）
 */
const HISTORY_KEY = 'search_history'
const MAX_HISTORY = 10

export interface SearchHistoryItem {
  keyword: string
  timestamp: number
}

export const useSearchHistory = () => {
  const history = ref<SearchHistoryItem[]>([])

  // 加载历史记录
  const loadHistory = () => {
    if (import.meta.server) return
    try {
      const stored = localStorage.getItem(HISTORY_KEY)
      history.value = stored ? JSON.parse(stored) : []
    } catch {
      history.value = []
    }
  }

  // 添加搜索记录
  const addHistory = (keyword: string) => {
    if (import.meta.server || !keyword.trim()) return
    
    // 去重并置顶
    const filtered = history.value.filter(h => h.keyword !== keyword)
    filtered.unshift({ keyword, timestamp: Date.now() })
    
    // 限制数量
    history.value = filtered.slice(0, MAX_HISTORY)
    
    // 保存到 localStorage
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history.value))
    } catch {
      // localStorage 可能已满或被禁用
    }
  }

  // 删除单条历史
  const removeHistory = (keyword: string) => {
    if (import.meta.server) return
    history.value = history.value.filter(h => h.keyword !== keyword)
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history.value))
    } catch {
      // ignore
    }
  }

  // 清空所有历史
  const clearHistory = () => {
    if (import.meta.server) return
    history.value = []
    try {
      localStorage.removeItem(HISTORY_KEY)
    } catch {
      // ignore
    }
  }

  // 组件挂载时加载
  onMounted(() => {
    loadHistory()
  })

  return {
    history: readonly(history),
    addHistory,
    removeHistory,
    clearHistory,
    loadHistory
  }
}
